export default[
    {
        path: '/folhar/evento/cadastro',
        name: 'cadastro do evento', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/folhar/evento/lista/:folhar_id',
        name: 'lista do evento', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/folhar/tomador/lista/:folhar_id',
        name: 'lista do tomador', 
        component: () => import(/* webpackChunkName: "Login" */ './page/listatomador.vue')
    },
    {
        path: '/folhar/evento/editar/:id',
        name: 'editar evento', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]